<template>
  <content-dialog
    :visible.sync="modalVisible"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :small-title="$vuetify.breakpoint.smAndDown"
    :persistent="$store.state.ui.alert.active"
    max-width="700px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      Assign to
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text :class="{'pa-5': $vuetify.breakpoint.smAndUp }">
      <assignee-modal-select
        v-model="assignedTo"
        v-validate="'required'"
        :dialog-visible.sync="assigneeModalSelectVisible"
        data-vv-as="Finished By"
        name="assigned_to"
        :error-message="veeErrors.first('assigned_to')"
        multiple
        outlined
        clearable
        chips
        deletable-chips
        label="Assign To"
        @submit="assigneeModalSelectVisible = false"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import ContentDialog from '@/components/helpers/Dialog'
  import ServiceTask from '@/models/ServiceTask'
  import AssigneeModalSelect from '@/components/service/helpers/AssigneeModalSelect'

  export default {
    name: 'ServiceTaskAssignToDialog',
    components: {
      AssigneeModalSelect,
      ContentDialog
    },
    props: {
      visible: Boolean,
      serviceTask: {
        type: [Object, Array],
        default: () => ServiceTask.emptyModel
      }
    },
    data() {
      return {
        assignedTo: [],
        assigneeModalSelectVisible: false,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      isBatch() {
        return Array.isArray(this.serviceTask)
      },
      currentEmployee() {
        return this.$store.state.auth.user.staff
      }
    },
    watch: {
      serviceTask: function () {
        this.assignedTo = []

        if (!this.isBatch && this.serviceTask.assigned_to.length) {
          this.assignedTo = cloneDeep(this.serviceTask.assigned_to)
          return
        }

        this.pushCurrentEmployee()
      }
    },
    mounted() {
      this.pushCurrentEmployee()
    },
    methods: {
      async submit() {
        let validation = await this.$validator.validate()

        if (!validation) return

        this.updateServiceTask()
      },
      async updateServiceTask() {
        this.submitting = true

        let formData = {
          service_tasks_ids: this.isBatch ? this.serviceTask : [this.serviceTask.id],
          assigned_to: this.assignedTo.map(assignee => {
            return {
              type: assignee.type,
              id: assignee.id
            }
          })
        }

        try {
          let serviceTasks = await ServiceTask.api.updateAssignedTo(formData)

          this.$store.dispatch('alert', {
            'text': `${serviceTasks.length} Service Tasks Updated`,
            'color': 'success'
          })
          // todo: table update
          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      },
      pushCurrentEmployee() {
        let employee = cloneDeep(this.currentEmployee)
        employee.type = ServiceTask.ASSIGNEE_TYPE_STAFF

        this.assignedTo.push(employee)
      }
    }
  }
</script>
